export default "__VITE_ASSET__xphxTTwI__"